// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.map-attribution {
  background: rgb(255 255 255 / 75%);
  bottom: 0;
  color: rgb(0 0 0 / 75%);
  font: 10px/18px "Helvetica Neue", Arial, sans-serif;
  padding: 0 5px;
  position: absolute;
  right: 0;
  z-index: 10;
}

.map-attribution a {
  color: inherit;
  text-decoration: none;
}

.map-attribution a:hover {
  text-decoration: underline;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1hcC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBYztFQUNkLFlBQVk7QUFDZDs7QUFFQTtFQUNFLGtDQUFrQztFQUNsQyxTQUFTO0VBQ1QsdUJBQXVCO0VBQ3ZCLG1EQUFtRDtFQUNuRCxjQUFjO0VBQ2Qsa0JBQWtCO0VBQ2xCLFFBQVE7RUFDUixXQUFXO0FBQ2I7O0FBRUE7RUFDRSxjQUFjO0VBQ2QscUJBQXFCO0FBQ3ZCOztBQUVBO0VBQ0UsMEJBQTBCO0FBQzVCIiwiZmlsZSI6Im1hcC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICBkaXNwbGF5OiBibG9jaztcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG4ubWFwLWF0dHJpYnV0aW9uIHtcbiAgYmFja2dyb3VuZDogcmdiKDI1NSAyNTUgMjU1IC8gNzUlKTtcbiAgYm90dG9tOiAwO1xuICBjb2xvcjogcmdiKDAgMCAwIC8gNzUlKTtcbiAgZm9udDogMTBweC8xOHB4IFwiSGVsdmV0aWNhIE5ldWVcIiwgQXJpYWwsIHNhbnMtc2VyaWY7XG4gIHBhZGRpbmc6IDAgNXB4O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHJpZ2h0OiAwO1xuICB6LWluZGV4OiAxMDtcbn1cblxuLm1hcC1hdHRyaWJ1dGlvbiBhIHtcbiAgY29sb3I6IGluaGVyaXQ7XG4gIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbn1cblxuLm1hcC1hdHRyaWJ1dGlvbiBhOmhvdmVyIHtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/map/map.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,uBAAuB;EACvB,mDAAmD;EACnD,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,ggCAAggC","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.map-attribution {\n  background: rgb(255 255 255 / 75%);\n  bottom: 0;\n  color: rgb(0 0 0 / 75%);\n  font: 10px/18px \"Helvetica Neue\", Arial, sans-serif;\n  padding: 0 5px;\n  position: absolute;\n  right: 0;\n  z-index: 10;\n}\n\n.map-attribution a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.map-attribution a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
